import axios from "axios";
import { MainUrl } from "../constants";

const API_URL = `${MainUrl}/service_note`;

export const createServiceNote = async (token, body) => {
  try {
    const response = await axios.post(`${API_URL}/`, body, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("access_level");
      window.location.href = "/";
    }
    return error.response?.data ?? { detail: "Ошибка создания служебной записки" };
  }
};

export const listServiceNotes = async (token, filters) => {
  try {
    const response = await axios.post(`${API_URL}/list/`, filters, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("access_level");
      window.location.href = "/";
    }
    return error.response?.data ?? { detail: "Ошибка загрузки служебных записок" };
  }
};

export const getServiceNote = async (token, noteId) => {
  try {
    const response = await axios.get(`${API_URL}/${noteId}/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("access_level");
      window.location.href = "/";
    }
    return error.response?.data ?? { detail: "Ошибка загрузки служебной записки" };
  }
};

export const approveServiceNote = async (token, noteId, body) => {
  try {
    const response = await axios.post(`${API_URL}/${noteId}/approve/`, body, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("access_level");
      window.location.href = "/";
    }
    const detail = error.response?.data?.detail;
    return detail ? { detail } : { detail: "Ошибка согласования" };
  }
};
